import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import createTaskTypeImg from "../../content/img/create-tasktype.svg";
import { CheckBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import { TasktypeInput } from "./TaskTypeInput";
import { TaskTypeInputCard } from "./TaskTypeInputCard";

export const CreateTaskTypeForm = forwardRef(({ id, initState }, ref) => {
  const { t } = useTranslation(["CreateBoardModal", "Shared"]);
  const taskTypeRefs = useRef([]);
  const includeTaxReturnRef = useRef();
  const [additionalTaskTypes, setAdditionalTaskTypes] = useState(
    initState.slice(1).map((s) => ({ ...s }))
  );

  const ids = {
    item: (index) => id + "_task-type-item-" + index,
  };

  const removeAdditionalTaskType = (indexToRemove) => {
    setAdditionalTaskTypes((prev) =>
      prev?.filter((e, index) => index !== indexToRemove)
    );
  };

  const addAdditionalTaskType = () => {
    const data = [...additionalTaskTypes, { key: "", title: "" }];
    setAdditionalTaskTypes(data);
  };

  const updateAdditionalTaskType = (index, value) => {
    setAdditionalTaskTypes((prev) => {
      let data = [...prev];
      data[index] = value;
      return data;
    });
  };

  const getValue = () =>
    taskTypeRefs.current?.filter?.((x) => !!x).map((c) => c.getValue());

  const validate = () => {
    const allTitlesAndKeysEmpty = taskTypeRefs.current
      ?.filter?.((x) => !!x)
      .every((ttRef) => {
        const value = ttRef.getValue();
        return value.title === "" && value.key === "";
      });

    if (includeTaxReturnRef?.current?.checked && allTitlesAndKeysEmpty) {
      return true;
    }

    return taskTypeRefs.current
      ?.filter((x) => !!x)
      .reduce((prev, ttRef) => prev && ttRef.validate(), true);
  };

  useImperativeHandle(
    ref,
    () => ({
      getValue,
      getIncludeTaxReturnRef: () => includeTaxReturnRef.current?.checked,
      validate,
      isValid: () => true,
    }),
    [includeTaxReturnRef]
  );

  return (
    <div id={id} className="create-board-modal-content task-type-form">
      <div className="picture-container">
        <img src={createTaskTypeImg} height={145} />
        <p className="picture-message">{t("CreateTaskTypePicture")}</p>
      </div>

      <div>
        <TasktypeInput
          id={ids.item(0)}
          key={0}
          className={"mb-4"}
          initialValue={initState[0]}
          ref={(ttiRef) => (taskTypeRefs.current[0] = ttiRef)}
        />
      </div>

      {additionalTaskTypes.map((tt, i) => (
        <TaskTypeInputCard
          id={ids.item(i + 1)}
          key={i}
          initialValue={tt}
          ref={(ttiRef) => (taskTypeRefs.current[i + 1] = ttiRef)}
          onBlur={(e) => updateAdditionalTaskType(i, e.value)}
          remove={() => removeAdditionalTaskType(i)}
        />
      ))}

      <button
        className="add-tasktype-btn btn text-start btn-secondary"
        onClick={addAdditionalTaskType}
      >
        <i className="fa-regular fa-plus et-blue me-3" />
        {t("AddTaskType")}
      </button>

      <hr className="bg-et-gray" />

      <div className="include-tax-return">
        <div className="mx-3 my-2">
          <CheckBox
            ref={includeTaxReturnRef}
            label={t("IncludeTaxReturnLabel")}
          />
        </div>
        <div className="my-2 fs-12 sub-label">
          {t("IncludeTaxReturnSublabel")}
        </div>
      </div>
    </div>
  );
});
